<template>
  <div
    style="width: 100%; display: flex; flex-wrap: wrap; flex-direction: column"
  >
    <v-menu
      ref="menu"
      v-model="menu2"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
      style="z-index: 100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-select
          v-if="multiple"
          :value="times"
          :label="label"
          :placeholder="placeholder || $t('new-event.time-placeholder')"
          persistent-placeholder
          append-icon="mdi-clock-time-four-outline"
          readonly
          class="rounded-lg"
          hide-details
          v-bind="attrs"
          v-on="on"
          outlined
          dense
          :disabled="disabled"
          color="primary"
          :rules="rules"
          multiple
          chips
          deletable-chips
          @change="updateTimes"
          :items="times"
          @click.native="menu2 = true"
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click:close="removeTime(data.item)"
            >
              {{ formatTime(data.item) }}
            </v-chip>
          </template>
        </v-select>
        <v-text-field
          v-else
          :value="displayTime"
          :label="label"
          :placeholder="placeholder || $t('new-event.time-placeholder')"
          persistent-placeholder
          append-icon="mdi-clock-time-four-outline"
          readonly
          class="rounded-lg"
          hide-details
          v-bind="attrs"
          v-on="on"
          outlined
          dense
          :disabled="disabled"
          color="primary"
          :rules="rules"
        />
      </template>
      <v-time-picker
        v-if="menu2"
        v-model="tempTime"
        @click:minute="saveTime"
        color="primary"
        format="24hr"
        locale="pt"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export default {
  name: "TimePicker",
  data() {
    return {
      menu2: false,
      tempTime: null,
      times: this.value && this.multiple ? [...this.value] : [],
      displayTime: "",
    };
  },
  props: {
    edit: [String, Array],
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Array],
      default: "",
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    edit(newValue) {
      if (this.multiple) {
        if (newValue === null || newValue === undefined) {
          this.times = [];
        } else {
          this.times = [...newValue];
        }
      } else {
        this.tempTime = newValue;
      }
      this.updateDisplayTime();
    },
    value(newValue) {
      if (this.multiple) {
        this.times = newValue || [];
      } else {
        this.tempTime = newValue;
      }
      this.updateDisplayTime();
    },
  },
  computed: {
    editComputed: {
      get() {
        return this.edit;
      },
      set(newValue) {
        this.$emit("edit", newValue);
      },
    },
  },
  methods: {
    dayjs,
    saveTime() {
      if (this.multiple) {
        if (this.tempTime && !this.times.includes(this.tempTime)) {
          this.times.push(this.tempTime);
          this.$emit("input", this.times);
          this.tempTime = null;
          this.menu2 = false;
          setTimeout(() => {
            this.menu2 = true;
          }, 100);
        }
      } else {
        this.menu2 = false;
        this.$emit("input", this.tempTime);
      }
      this.updateDisplayTime();
    },
    updateDisplayTime() {
      if (this.multiple) {
        if (this.value === null || this.value === undefined) {
          this.displayTime = "";
        }
      } else {
        this.displayTime = this.tempTime ? this.formatTime(this.tempTime) : "";
      }
    },
    formatTime(time) {
      return dayjs(time, "HH:mm").format("HH:mm");
    },
    removeTime(time) {
      this.times = this.times.filter(t => t !== time);
      this.$emit("input", this.times);
      this.updateDisplayTime();
    },
    updateTimes(newTimes) {
      this.times = newTimes;
      this.$emit("input", this.times);
    },
  },
  mounted() {
    if (this.editComputed) {
      this.tempTime = this.value;
    }
    this.updateDisplayTime();
  },
};
</script>
